import { render, staticRenderFns } from "./third-party.vue?vue&type=template&id=d8f200c6&scoped=true"
import script from "./third-party.vue?vue&type=script&lang=js"
export * from "./third-party.vue?vue&type=script&lang=js"
import style0 from "./third-party.vue?vue&type=style&index=0&id=d8f200c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f200c6",
  null
  
)

export default component.exports